import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

import { ref } from "vue";
import { ConfigFundTypeSelections } from "@/core/types/FundTypes";
import PaymentService from "../services/PaymentService";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import i18n from "@/core/plugins/i18n";

export default /*#__PURE__*/_defineComponent({
  __name: 'ChangeWalletFundType',
  emits: ["eventSubmit"],
  setup(__props, { expose: __expose, emit: emits }) {

const { t } = i18n.global;
const isLoading = ref(false);
const dialogVisible = ref(false);
const fundType = ref<any>(null);
const walletId = ref(0);
const show = (data: any) => {
  dialogVisible.value = true;
  fundType.value = data.fundType;
  walletId.value = data.id;
};

const handleSubmit = async () => {
  isLoading.value = true;
  try {
    await PaymentService.changeWalletFundType(walletId.value, fundType.value);
    MsgPrompt.success(t("status.success"));
    emits("eventSubmit");
  } catch (e) {
    MsgPrompt.error(t("status.error"));
    console.log(e);
  }
  isLoading.value = false;
  dialogVisible.value = false;
};

__expose({
  show,
});

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: "Change Fund Type",
    modelValue: dialogVisible.value,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((dialogVisible).value = $event)),
    width: "30%",
    "align-center": ""
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (dialogVisible.value = false))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("action.cancel")), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: handleSubmit
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("action.save")), 1)
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_select, {
        modelValue: fundType.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((fundType).value = $event))
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ConfigFundTypeSelections), (item) => {
            return (_openBlock(), _createBlock(_component_el_option, {
              key: item.value,
              label: item.label,
              value: item.value
            }, null, 8, ["label", "value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})